__turbopack_context__.v({
  "dialog": "T1yHVa_dialog",
  "dialog--submitted": "T1yHVa_dialog--submitted",
  "dialog__pdf-document-content-container": "T1yHVa_dialog__pdf-document-content-container",
  "dialog__preview-and-form-wrapper": "T1yHVa_dialog__preview-and-form-wrapper",
  "dialog__printable-pdf-view": "T1yHVa_dialog__printable-pdf-view",
  "dialog__printable-pdf-view--printing": "T1yHVa_dialog__printable-pdf-view--printing",
  "form-container": "T1yHVa_form-container",
  "form-container__contact-information-block-inputs": "T1yHVa_form-container__contact-information-block-inputs",
  "form-container__date-block": "T1yHVa_form-container__date-block",
  "form-container__date-block-title": "T1yHVa_form-container__date-block-title",
  "form-container__date-picker": "T1yHVa_form-container__date-picker",
  "form-container__donation-block": "T1yHVa_form-container__donation-block",
  "form-container__donation-block-inputs": "T1yHVa_form-container__donation-block-inputs",
  "form-container__form-section-heading": "T1yHVa_form-container__form-section-heading",
  "form-container__personal-anecdote-block": "T1yHVa_form-container__personal-anecdote-block",
  "form-container__personal-information-block": "T1yHVa_form-container__personal-information-block",
  "form-container__personal-information-block-inputs": "T1yHVa_form-container__personal-information-block-inputs",
  "form-container__professional-information-block-inputs": "T1yHVa_form-container__professional-information-block-inputs",
  "section-description": "T1yHVa_section-description",
  "section-title": "T1yHVa_section-title",
});
